import { DayPickerButton } from "@/components/Inputs/RangePicker/components/DayPickerButton/DayPickerButton.tsx";
import { useRangePickerDayPickerProps } from "@/components/Inputs/RangePicker/hooks/useRangePickerDayPickerProps.tsx";
import { useRangePickerOutsideInteractions } from "@/components/Inputs/RangePicker/hooks/useRangePickerOutsideInteractions.ts";
import { useRangePickerScrollBehavior } from "@/components/Inputs/RangePicker/hooks/useRangePickerScrollBehavior.ts";
import { RangePickerProps } from "@/components/Inputs/RangePicker/RangePickerProps.ts";
import { useRef, useState } from "react";
import { DayPicker } from "react-day-picker";

export const RangePicker = (props: RangePickerProps) => {
  const [hideDatePicker, setHideDatePicker] = useState(true);
  const { onChange, startDate, endDate } = props;
  const dayPickerRef = useRef<HTMLDivElement>(null);

  useRangePickerOutsideInteractions(dayPickerRef, setHideDatePicker);
  useRangePickerScrollBehavior(hideDatePicker);

  const dayPickerProps = useRangePickerDayPickerProps({
    startDate,
    endDate,
    onChange,
    filterDate: props.filterDate,
    setHideDatePicker,
  });

  return (
    <div
      className={`c-be-range-picker-wrapper ${!hideDatePicker ? "c-be-range-picker-wrapper--open" : ""}`}
      ref={dayPickerRef}
    >
      <DayPickerButton
        disabled={!!props.disabled}
        setHideDatePicker={setHideDatePicker}
        startDate={startDate}
        endDate={endDate}
        prefixIcon={props.prefixIcon}
      />
      <div className={`${hideDatePicker ? "daypicker-popup_hide" : "daypicker-popup"}`}>
        <DayPicker {...dayPickerProps} />
      </div>
    </div>
  );
};
